import { type } from 'jquery';
import Elements from './elements';

const DOC = document;
const WIN = window;

const __Tooltip = {

	elements: [],

	instances: [],

};

const TooltipInitializer = function (el, options) {

	const CORE = {

		__canInit: function () {
			let i = 0;

			if (!__Tooltip.elements.length) {
				return true;
			}

			for (i; i < __Tooltip.elements.length; i++) {
				if (__Tooltip.elements[i] === el) {
					return false;
				}
			}
			return true;

		},

		button: {

			elements: null,

			toggle: function () {
				var els = CORE.message.elements;

				if (els === null) {
					return;
				}

				if (CORE.message.hidden) {
					$(els).show();
					CORE.message.hidden = false;
					return;

				}
				$(els).hide();
				CORE.message.hidden = true;
			},

			getPosition: function (_el) {

				return _el.getBoundingClientRect();

			},

			onOver: function (e) {
				const pos = CORE.button.getPosition(this);

				e.preventDefault();

				CORE.desc.setPosition(pos.x, pos.y);
				CORE.desc.toggle(false);

			},

			onLeave: function (e) {
				e.preventDefault();

				CORE.desc.setPosition(null, null);
				CORE.desc.toggle(true);

			},

			construct: function () {
				CORE.button.elements = Elements({
					selector: options.classNames.button,
					element: el,
					onElement: function (_el) {
						_el.addEventListener('mouseenter', CORE.button.onOver);
						_el.addEventListener('mouseleave', CORE.button.onLeave);

					}
				})

			}

		},

		desc: {

			hidden: true,

			elements: null,

			toggle: function (hide) {
				let i = 0;
				const els = CORE.desc.elements;

				hide = typeof hide === 'boolean' ? hide : false;

				CORE.desc.hidden = hide;

				for (i; i < els.length; i++){
					els[i].style.position = hide ? null : 'fixed';
				}

			},

			setPosition: function (x, y) {
				let i = 0;
				const els = CORE.desc.elements;

				for (i; i < els.length; i++){
					els[i].style.top = typeof y === 'number' ? parseInt(y) + 'px' : null;
					els[i].style.left = typeof x === 'number' ? parseInt(x) + 'px' : null;
				}

			},

			construct: function () {

				CORE.desc.elements = Elements({
					selector: options.classNames.desc,
					element: el,
				});

			}

		},

		onWindow: function (e) {
			let i = 0;
			const els = CORE.button.elements;
			var pos;

			if (CORE.desc.hidden) {
				return;
			}

			for (i; i < els.length; i++){
				pos = CORE.button.getPosition(els[i]);
				CORE.desc.setPosition(pos.x, pos.y);

			}

		}

	};

	if (!CORE.__canInit()) {
		return false;
	}
	CORE.button.construct();
	CORE.desc.construct();

	if (CORE.button.elements === null || CORE.desc.elements === null) {
		return false;
	}

	WIN.addEventListener('scroll', CORE.onWindow);
	WIN.addEventListener('resize', CORE.onWindow);

	__Tooltip.elements[__Tooltip.elements.length] = el;

	return true;
};

const Tooltip = function (options) {
	var parentNode = DOC;

	if (typeof options !== 'object' || options == null) {
		return;
	}

	if (!('classNames' in options) || typeof options.classNames !== 'object') {
		return;
	}

	if ('parentNode' in options && typeof options.parentNode === 'object' && options.parentNode !== null && 'nodeName' in options.parentNode) {
		parentNode = options.parentNode;
	}

	if ('element' in options && typeof options.element === 'object' && options.element !== null && 'nodeName') {
		TooltipInitializer(options.element, options);
		return;

	}

	Elements({
		selector: options.classNames.tooltip,
		element: parentNode,
		onElement: function (el) {
			TooltipInitializer(el, options);
		}
	});

	return {

		refresh: function () {
			Tooltip(options);

		}
	};

};

export default Tooltip;